<template>
    <footer class="footer-wrapper bg-white relative z-10 xl:pt-spc13 xl:pb-spc5 xl:px-spc7 md:pt-spc5 md:pb-20">
        <div class="container">
            <div class="footer-content flex items-start justify-between xl:flex-row md:flex-col">
                <div class="left xl:w-3/5 md:w-full">
                    <router-link to="/" class="logo w-spc3 inline-block">
                        <img class="w-full" :src="require('@/assets/images/logo.png')" alt="Logo">
                    </router-link>
                    <span v-if="title" class="footer-text block text-size5 text-secondary font-bold mt-1 mb-3">
                        {{title}}
                    </span>

                    <FooterMenu />
                </div>

                <FooterRight />
            </div>
        </div>
    </footer>
</template>

<script>
    import FooterMenu from "./FooterMenu";
    import FooterRight from "./FooterRight";
    export default {
        name: "Footer",
        props: ['title'],
        components: {
            FooterRight,
            FooterMenu
        }
    }
</script>

<style scoped>

</style>